import React, {useRef} from 'react';
import { Col, Container, Row } from 'react-bootstrap'
import bookingFailedImg from '../../../assets/images/booking-failed.svg'; // Replace with your actual image path
import Image from '../../atoms/Image/Image';
import { useLocation, Link } from 'react-router';
const BookingResponse = () => {
  const location = useLocation();
  const { serverResponse } = location.state;
  const voucherRef = useRef(null);
  const HtmlRenderer = ({ htmlContent }) => {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  };
  const handlePrint = () => {
      const printContents = voucherRef.current.innerHTML;
      const printWin =  window.open(
          '_blank',    
      );
      printWin.document.open();
      printWin.document.write(printContents);
      printWin.document.close();
      printWin.onload = () => {
          setTimeout(() => {
              printWin.print();
              printWin.close();
          }, 0);
      };
  };
  return (
  <>
    {serverResponse?.status == true ?  (
      <div className='sucess'>
        <div className="pt-5" style={{display:"flex", justifyContent:"center"}}>
          <button type="button" className="btn-custom" onClick={handlePrint}>Print</button>
        
        </div>
        <div  style={{
            maxWidth: "900px",
            margin: " 30px auto 50px",
            boxShadow: "2px 3px 7px 2px #ccc",
            padding: "0px; 0px 50px"
        }}>
          <div ref={voucherRef} className="voucher">
            <HtmlRenderer htmlContent={serverResponse?.data?.invoice} />
          </div>
        </div>
        
      </div>
    ) : (
      <div className="booking-failed section-padding">
        <Container>
          <Row>
            <Col className="col-12 text-center">
              <figure className="booking-failed__image-wrapper d-flex justify-content-center">
                <Image
                  src={bookingFailedImg}
                  alt="Booking Failed"
                  width="169"
                  height="150"
                />
              </figure>
              <h1 className="booking-failed__title">{serverResponse?.message || 'Booking Failed'}</h1>
              <p className="booking-failed__message">
                Oops! Something went wrong. Please try again later.
              </p>
              <div className="booking-failed__action mt-4">
                <Link className="booking-failed__button btnfilled button-2 btn-custom" to="/">
                  Back to Homepage
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
  )}
  </>);
};

export default BookingResponse;
